import router from '@/router'
import { auth, providers, db } from '@/config'
import localforage from 'localforage'

export default {
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    email: null,
    signup: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
      if (payload) {
        localStorage.setItem('user', JSON.stringify(payload))
      } else localStorage.removeItem('user')
    },
    setEmail (state, payload) {
      state.email = payload
    },
    setSignup (state, payload) {
      state.signup = payload
    }
  },
  actions: {
    userSignUp ({ commit, dispatch }, payload) {
      commit('setLoading', true)
      return auth.createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          commit('setUser', {
            id: firebaseUser.user.uid,
            uid: firebaseUser.user.uid,
            name: firebaseUser.user.displayName,
            email: firebaseUser.user.email
          })
          commit('setLoading', false)
          // router.push({ path: router.currentRoute.query.from || '/' })
          dispatch('log_access', { event: 'register' }, { root: true })
          return firebaseUser.user.uid
        })
        .catch(error => {
          commit('setError', 'Error credenciales')
          commit('setLoading', false)
          return false
        })
    },
    userSignIn ({ commit, dispatch }, payload) {
      commit('setLoading', true)
      return auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(async (firebaseUser) => {
          if (firebaseUser.user) {
            const user = {
              id: firebaseUser.user.uid,
              uid: firebaseUser.user.uid,
              name: firebaseUser.user.displayName,
              email: firebaseUser.user.email
            }
            commit('setUser', user)
            commit('setLoading', false)
            commit('setError', null)
            dispatch('log_access', { event: 'login' }, { root: true })
            router.replace({
              path: router.currentRoute.query.from || '/',
              query: { action: router.currentRoute.query.action }
            })
            return { sucess: true, uid: firebaseUser.user.uid }
          } else {
            throw new Error('Error credenciales')
          }
        })
        .catch(error => {
          commit('setError', 'Error credenciales')
          commit('setLoading', false)
        })
    },
    async userSignInProvider ({ commit, dispatch }, provider) {
      commit('setLoading', true)
      return auth.signInWithPopup(providers[provider])
        .then(async (firebaseUser) => {
          if (firebaseUser.user) {
            commit('setUser', {
              id: firebaseUser.user.uid,
              uid: firebaseUser.user.uid,
              name: firebaseUser.user.displayName,
              email: firebaseUser.user.email
            })
            commit('setLoading', false)
            commit('setError', null)
            const res = await db.doc(`users_privacy/${firebaseUser.user.uid}`).get()
            const signup = !res.exists
            if (signup) {
              router.replace({ name: 'Home' })
            } else {
              router.replace({
                path: router.currentRoute.query.from || '/',
                query: { action: router.currentRoute.query.action }
              })
            }
            return { sucess: true, uid: firebaseUser.user.uid }
          } else {
            throw new Error('Error credenciales')
          }
        })
        .catch(error => {
          commit('setError', 'Error credenciales')
          commit('setLoading', false)
          console.error(error)
        })
    },
    autoSignIn ({ commit, dispatch }, payload) {
      console.log('autoSignIn')
      if (payload && payload.uid) {
        const user = {
          id: payload.uid,
          uid: payload.uid,
          email: payload.email
        }
        localStorage.setItem('user', user)
        commit('setUser', user)
        dispatch('log_access', { event: 'login' }, { root: true })
      } else {
        commit('setUser', null)
      }
    },
    async userSignOut ({ commit }) {
      await auth.signOut()
      commit('setUser', null)
      location.href = '/'
    },
    async userDelete({ commit }) {
      await auth.currentUser.delete()
      commit('setUser', null)
      commit('setEmail', null)
      commit('setSignup', null)
      router.replace({ name: 'Signout' })
    },
    requireLogin ({}, action) {
      const from = router.currentRoute.path.length > 2 ? router.currentRoute.path : ''
      router.push({ name: 'Signin', query: { from, action } })
    }
  },
  getters: {
    user: (state) => (state.user),
    email: (state) => (state.email),
    signup: (state) => (state.signup),
    isAuthenticated (state) {
      return state.user !== null && state.user !== undefined
    }
  }
}
